import { Components, Theme } from "@mui/material/styles";
import { Grey } from "../colors";

export const MuiTextFieldComponent: Components<Theme>["MuiTextField"] = {
    variants: [
        {
            props: {
                variant: "outlined",
                size: "small",
            },
            style: {
                minWidth: 200,
                "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    "& fieldset": {
                        borderColor: Grey[70],
                    },
                },
            },
        },
    ],
};
